import React from 'react';
import SectionSearchBar from '../../../components/ui/SectionSearchBar';

interface EventFiltersProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  onClearSearch: () => void;
  statusFilter: string;
  onStatusFilterChange: (status: string) => void;
  viewMode: 'calendar' | 'list';
  onViewModeChange: (mode: 'calendar' | 'list') => void;
  language: 'en' | 'ar';
  isRTL: boolean;
  strings: any;
}

const EventFilters: React.FC<EventFiltersProps> = ({
  searchQuery,
  onSearchChange,
  onClearSearch,
  statusFilter,
  onStatusFilterChange,
  viewMode,
  onViewModeChange,
  language,
  isRTL,
  strings
}) => {
  return (
    <div className={`flex flex-col sm:flex-row gap-4 ${isRTL ? 'sm:flex-row-reverse' : ''}`}>
      <div className="flex-1">
        <SectionSearchBar
          searchQuery={searchQuery}
          onSearchChange={onSearchChange}
          onClearSearch={onClearSearch}
          placeholder={language === 'ar' ? 'البحث في الأحداث...' : 'Search events...'}
          language={language}
          isRTL={isRTL}
        />
      </div>
      
      {/* Status Filter and View Mode Switcher */}
      <div className={`flex gap-3 ${isRTL ? 'flex-row-reverse' : ''}`}>
        {/* Status Filter */}
        <div className="relative">
          <select
            value={statusFilter}
            onChange={(e) => onStatusFilterChange(e.target.value)}
            className={`px-4 py-2 border border-slate-200 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-2 focus:ring-primary focus:border-transparent min-w-[150px] ${
              isRTL ? 'text-right' : 'text-left'
            }`}
            style={{
              textAlign: isRTL ? 'right' : 'left'
            }}
          >
            <option value="all">
              {language === 'ar' ? 'جميع الحالات' : 'All Status'}
            </option>
            <option value="1">
              {language === 'ar' ? 'قادم' : 'Upcoming'}
            </option>
            <option value="2">
              {language === 'ar' ? 'مكتمل' : 'Completed'}
            </option>
            <option value="3">
              {language === 'ar' ? 'ملغي' : 'Cancelled'}
            </option>
          </select>
        </div>

        {/* View Mode Switcher */}
        <div className="flex rounded-lg border border-slate-200 dark:border-slate-700 overflow-hidden">
          <button
            onClick={() => onViewModeChange('calendar')}
            className={`px-4 py-2 text-sm font-medium transition-colors ${
              viewMode === 'calendar'
                ? 'bg-primary text-white'
                : 'bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700'
            }`}
          >
            {language === 'ar' ? 'تقويم' : 'Calendar'}
          </button>
          <button
            onClick={() => onViewModeChange('list')}
            className={`px-4 py-2 text-sm font-medium transition-colors border-l border-slate-200 dark:border-slate-700 ${
              viewMode === 'list'
                ? 'bg-primary text-white'
                : 'bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700'
            }`}
          >
            {language === 'ar' ? 'قائمة' : 'List'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EventFilters;
